module.exports = __webpack_public_path__ + "static/media/CTLI_5-315w.26cbd3f6.webp";